import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Tooltip from "@mui/material/Tooltip";
import Pagination from "./../Pagination";
import AscendingSort from "./../../images/ascendingSort.png";
import DescendingSort from "./../../images/descendingSort.png";
import CheckboxChecked from "./../../images/checkboxClicked.png";
import Checkbox from "./../../images/checkboxUnclicked.png";
import Sort from "./../../images/sort.png";
import Alert from "./../../images/alert.png";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import NoDataBox from "../ReusableSmallComponents/noDataBox";

import style from "./index.module.scss";
import HistoryPopup from "../HistoryPopup/historyPopup";
import { GET } from "../../Screens/dataSaver";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    pointerEvents: "auto",
  },
}));

const Table = ({
  tableHeaderValues,
  tableDataValues,
  tableData,
  hidePagination,
  getNewContract,
  getContractType,
  getSelectedContractType,
  getContractIdFromActive,
  gridStyle,
  actions,
  getSelectedPage,
  totalCount,
  page,
  scrollStyle,
  tableSortValues,
  heading,
  subHeading,
  onClickText,
  onClickFunction,
  buttonComponent,
  getHandleSort,
  sortValue,
  allSelected,
  handleSelectAll,
  fullWidth = false,
  contractConfig,
  customCellRenderers,
  selectedContract,
  hideActionMenuIfNoActions = false,
  shouldHideActionMenuForRow, // optional (row) => boolean
  useDropdownForActions = false, // New prop for dropdown actions
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1);
  const [selectedMenuColIndex, setSelectedMenuColIndex] = useState(-1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElIcon, setAnchorElIcon] = useState(null);
  const openIcon = Boolean(anchorElIcon);
  const [anchorElIconWithCount, setAnchorElIconWithCount] = useState(null);
  const openIconWithCount = Boolean(anchorElIconWithCount);
  const [anchorElCountWithHover, setAnchorElCountWithHover] = useState(null);
  const openCountWithHover = Boolean(anchorElCountWithHover);
  const [anchorElTextWithHover, setAnchorElTextWithHover] = useState(null);
  const openTextWithHover = Boolean(anchorElTextWithHover);
  const open = Boolean(anchorEl);
  const [anchorElSite, setAnchorElSite] = useState(null);
  const openSite = Boolean(anchorElSite);
  const popoverAnchorSite = useRef(null);
  const [anchorElDept, setAnchorElDept] = useState(null);
  const openDept = Boolean(anchorElDept);
  const popoverAnchorDept = useRef(null);
  const [historyPop, setHistoryPop] = useState(false);
  const menuRef = useRef(null);
  const countHoverRef = useRef(null);
  const textHoverRef = useRef(null);
  const headerScrollRef = useRef(null);
  const bodyScrollRef = useRef(null);
  const [headerScrollbarOffset, setHeaderScrollbarOffset] = useState(0);
  useOptionsHide(menuRef);
  useOptionsHide(countHoverRef);
  useOptionsHide(textHoverRef);

  const availableSortValue = {
    CONTRACT_NAME: "NAME,Contract Name",
    CONTRACT_ID: "ID,Contract ID,CONTRACT ID",
    EFFECTIVE_DATE: "EFFECTIVE DATE,Contract Start",
    LAST_UPDATED: "LAST UPDATED,Last Updated,ECATS PROCESSING DATE",
    ACTIVIATION_STATUS: "ACTIVATION STATUS",
    EXPIRATION_DATE: "EXPIRATION DATE,Expiry Date,End Date",
    // EXTERNAL_CONTRACT_ID: "EXTERNAL CONTRACT ID",
    ACTION_DATE: "ACTION DATE",
    // LAST_REQUEST_SENT: "Last Request",
    EXTERNAL_CONTRACT_ID:
      "EXTERNAL CONTRACT ID,eCATS Number,eCATS Package ID,TSAI Contract ID,Expired Contract ID",
    LAST_MODIFIED_DATE:
      "eCATS Processing Date,Date Processed,Last Request,Last Processed Date,eCATS Processing Date",
    STATUS: "Status",
    SITE_ABBR: "HSP Code",
    NAME: "Contractor Name",
  };

  const availableSortValueEnum = Object.entries(availableSortValue).reduce(
    (acc, [field, labels]) => {
      labels?.split(",")?.forEach((label) => {
        acc[label?.trim()] = field;
      });
      return acc;
    },
    {}
  );

  console.log(availableSortValueEnum, selectedContract, "hhhhhhhhhhhhhhh");

  const handleClick = (event) => {
    // event.stopPropagation();
    console.log(event.currentTarget, "cuuuuuuuu");
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickIcon = (event, index, tableDataIndex) => {
    setAnchorElIcon(event.currentTarget);
    setSelectedMenuIndex(index);
    setSelectedMenuColIndex(tableDataIndex);
  };

  const handleCloseIcon = () => {
    setAnchorElIcon(null);
  };

  const handleClickIconWithCount = (event, index, tableDataIndex) => {
    setAnchorElIconWithCount(event.currentTarget);
    setSelectedMenuIndex(index);
    setSelectedMenuColIndex(tableDataIndex);
  };

  const handleCloseIconWithCount = () => {
    setAnchorElIconWithCount(null);
  };

  const handleClickCountWithHover = (event, index, tableDataIndex) => {
    setAnchorElCountWithHover(event.currentTarget);
    setSelectedMenuIndex(index);
    setSelectedMenuColIndex(tableDataIndex);
  };

  const handleCloseCountWithHover = () => {
    setAnchorElCountWithHover(null);
  };

  const handleClickTextWithHover = (event, index, tableDataIndex) => {
    setAnchorElTextWithHover(event.currentTarget);
    setSelectedMenuIndex(index);
    setSelectedMenuColIndex(tableDataIndex);
  };

  const handleCloseTextWithHover = () => {
    setAnchorElTextWithHover(null);
  };

  const id = open ? "simple-popover" : undefined;

  const handleClickSite = (event, index, tableDataIndex) => {
    setAnchorElSite(event.currentTarget);
    setSelectedMenuIndex(index);
    setSelectedMenuColIndex(tableDataIndex);
  };

  const handleCloseSite = () => {
    setAnchorElSite(null);
  };

  const handleClickDept = (event, index, tableDataIndex) => {
    setAnchorElDept(event.currentTarget);
    setSelectedMenuIndex(index);
    setSelectedMenuColIndex(tableDataIndex);
  };

  const handleCloseDept = () => {
    setAnchorElDept(null);
  };

  const classes = useStyles();

  function useOptionsHide(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const [isLoading, setIsLoading] = useState(false);
  const [historyData, setHisData] = useState([]);
  const [historyHearderData, setHeaderData] = useState([]);

  useEffect(() => {
    const updateScrollbarOffset = () => {
      if (!bodyScrollRef.current) return;
      const verticalScrollbarWidth =
        bodyScrollRef.current.offsetWidth - bodyScrollRef.current.clientWidth;
      setHeaderScrollbarOffset(
        verticalScrollbarWidth > 0 ? verticalScrollbarWidth : 0
      );
    };

    updateScrollbarOffset();
    window.addEventListener("resize", updateScrollbarOffset);
    return () => window.removeEventListener("resize", updateScrollbarOffset);
  }, [tableData?.length, scrollStyle]);

  const syncHeaderScroll = (event) => {
    if (headerScrollRef.current) {
      headerScrollRef.current.scrollLeft = event.currentTarget.scrollLeft;
    }
  };

  const handleHistory = async (data) => {
    console.log(data, "uniqId");
    // setIsLoading(true);
    // let apiUrl = `contract-managment-service/record/history?uniqueId=${uniqId}`;
    let apiUrl = `contract-managment-service/record/history/${data?.recordUniqueId}`;

    const historyAPIData = await GET(apiUrl);
    console.log(historyAPIData, "historyAPIData");
    setHisData(historyAPIData?.data ? [historyAPIData?.data] || [] : []);
    setHeaderData(data);
    // setIsLoading(false);
    setHistoryPop(true);
  };

  console.log(tableHeaderValues, "tableHeaderValues", tableData?.[0]?.contractType);

  return (
    !isLoading && (
      <div>
        <div>
          <div ref={headerScrollRef} className={style.headerScrollContainer}>
            <div
              className={`${fullWidth ? style.tableHeaderFullWidth : style.tableHeader
                } ${typeof gridStyle === "string" ? gridStyle : ""} ${style.marginTop10
                }`}
              style={
                typeof gridStyle === "object"
                  ? { ...gridStyle, paddingRight: `${headerScrollbarOffset}px` }
                  : { paddingRight: `${headerScrollbarOffset}px` }
              }
            >
              {tableHeaderValues?.map((datas, index) => {
                const hasRecPro =
                  typeof datas === "string" && datas.includes("rec_pro");

                const data = hasRecPro
                  ? datas.replace("rec_pro", "").trim()
                  : datas;
                return (
                  <div
                    className={`${style.displayInRow}  ${hasRecPro
                        ? style.verticandJustifylAlignCenter
                        : style.verticalAlignCenter
                      }`}
                    key={index}
                  >
                    {data === "CHECKBOX" ? (
                      <img
                        src={allSelected ? CheckboxChecked : Checkbox}
                        alt=""
                        className={`${style.CheckboxImgStyle} ${style.marginLeft30} ${style.cursorPointer}`}
                        onClick={handleSelectAll}
                      />
                    ) : (
                      <div
                        className={`${data === "" && style.marginLeft30} ${style.tableHeaderFontStyle
                          }`}
                      >
                        {data}
                      </div>
                    )}

                    {tableSortValues?.[index] &&
                      availableSortValueEnum[data] &&
                      sortValue?.sortByField === availableSortValueEnum[data] &&
                      sortValue?.sortBy === "ASCENDING" ? (
                      <img
                        src={AscendingSort}
                        alt=""
                        className={`${style.sortImgStyle} ${style.cursorPointer}`}
                        onClick={() =>
                          getHandleSort(availableSortValueEnum[data], "ASCENDING")
                        }
                      />
                    ) : tableSortValues?.[index] &&
                      availableSortValueEnum[data] &&
                      sortValue?.sortByField === availableSortValueEnum[data] &&
                      sortValue?.sortBy === "DESCENDING" ? (
                      <img
                        src={DescendingSort}
                        alt=""
                        className={`${style.sortImgStyle} ${style.cursorPointer}`}
                        onClick={() =>
                          getHandleSort(
                            availableSortValueEnum[data],
                            "DESCENDING"
                          )
                        }
                      />
                    ) : (
                      tableSortValues?.[index] && (
                        <img
                          src={Sort}
                          alt=""
                          className={`${style.sortImgStyle} ${style.cursorPointer}`}
                          onClick={() =>
                            getHandleSort(availableSortValueEnum[data], "NONE")
                          }
                        />
                      )
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div
            className={`${scrollStyle}`}
            ref={bodyScrollRef}
            onScroll={syncHeaderScroll}
          >
            {tableData?.length !== 0 ? (
              tableData?.map((data, index) => (
                <>
                  <div
                    className={`${fullWidth ? style.tableDataFullWidth : style.tableData
                      } ${typeof gridStyle === "string" ? gridStyle : ""} ${index % 2 === 0 && style.alternativeBackgroundColor
                      }`}
                    style={typeof gridStyle === "object" ? gridStyle : {}}
                    key={index}
                  >
                    {/* {console.log(tableDataValues,'tableDataValuesgygj')} */}
                    {tableDataValues?.map((tableData, tableDataIndex) =>
                      tableData?.type === "dot" ? (
                        <div
                          className={`${style.displayInRow} ${style.marginLeft30} ${style.verticalAlignCenter}`}
                        >
                          {(() => {
                            const val = tableData?.value?.[index];
                            if (
                              val &&
                              typeof val === "object" &&
                              val.type === "image" &&
                              val.src
                            ) {
                              return (
                                <img
                                  src={val.src}
                                  alt="warning"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    display: "block",
                                  }}
                                />
                              );
                            }
                            return (
                              <Tooltip
                                title={tableData?.tooltipValue?.[index]}
                                arrow
                              >
                                <div
                                  className={`${val === "green"
                                      ? style.green
                                      : val === "yellow"
                                        ? style.yellow
                                        : val === "grey"
                                          ? style.grey
                                          : val === "red"
                                            ? style.red
                                            : ""
                                    } ${val === "green"
                                      ? style.greenDotStyle
                                      : val === "yellow"
                                        ? style.yellowDotStyle
                                        : val === "red"
                                          ? style.redDotStyle
                                          : val === "grey"
                                            ? style.greyDotStyle
                                            : val === "purple"
                                              ? style.purpleDotStyle
                                              : ""
                                    }`}
                                ></div>
                              </Tooltip>
                            );
                          })()}
                        </div>
                      ) : tableData?.type === "dotWithNumber" ? (
                        <div
                          className={`${style.displayInRow} ${style.marginLeft30} ${style.verticalAlignCenter}`}
                        >
                          {tableData?.value?.[index] === "-" ? (
                            <span className={style.tableDataFontStyle}>-</span>
                          ) : (
                            <div
                              className={`${style.displayInRow} ${style.verticalAlignCenter}`}
                            >
                              <span
                                className={style.tableDataFontStyle}
                                style={{ marginRight: "8px", fontSize: "14px" }}
                              >
                                {tableData?.value?.[index]?.number}
                              </span>
                              <Tooltip
                                title={tableData?.tooltipValue?.[index]}
                                arrow
                              >
                                <div
                                  className={`${tableData?.value?.[index]?.color === "green"
                                      ? style.green
                                      : tableData?.value?.[index]?.color ===
                                        "yellow"
                                        ? style.yellow
                                        : tableData?.value?.[index]?.color ===
                                          "grey"
                                          ? style.grey
                                          : tableData?.value?.[index]?.color ===
                                            "red"
                                            ? style.red
                                            : ""
                                    } ${tableData?.value?.[index]?.color === "green"
                                      ? style.greenDotStyle
                                      : tableData?.value?.[index]?.color ===
                                        "yellow"
                                        ? style.yellowDotStyle
                                        : tableData?.value?.[index]?.color ===
                                          "red"
                                          ? style.redDotStyle
                                          : tableData?.value?.[index]?.color ===
                                            "grey"
                                            ? style.greyDotStyle
                                            : tableData?.value?.[index]?.color ===
                                              "purple"
                                              ? style.purpleDotStyle
                                              : ""
                                    }`}
                                ></div>
                              </Tooltip>
                            </div>
                          )}
                        </div>
                      ) : tableData?.type === "pill" ? (
                        <div
                          className={
                            tableData?.value?.[index] != ""
                              ? `${style.statuspill}`
                              : ""
                          }
                        >
                          {tableData?.value?.[index]}
                        </div>
                      ) : tableData?.type === "checkbox" ? (
                        <div
                          className={`${style.displayInRow} ${style.marginLeft30} ${style.verticalAlignCenter}`}
                        >
                          {tableData?.value?.[index] ? (
                            <img
                              src={CheckboxChecked}
                              alt=""
                              onClick={
                                tableData?.onClickFunction
                                  ? () => {
                                    tableData?.onClickFunction(data, index);
                                  }
                                  : () => { }
                              }
                              className={`${style.CheckboxImgStyle}`}
                            />
                          ) : (
                            <img
                              src={Checkbox}
                              alt=""
                              onClick={
                                tableData?.onClickFunction
                                  ? () => {
                                    tableData?.onClickFunction(data, index);
                                  }
                                  : () => { }
                              }
                              className={`${style.CheckboxImgStyle}`}
                            />
                          )}
                        </div>
                      ) : tableData?.type === "custom" ? (
                        <div
                          className={`${style.tableDataFontStyle} ${style.verticandJustifylAlignCenter}`}
                          style={{ width: "100%", boxSizing: "border-box" }}
                        >
                          {tableData?.value?.[index] || null}
                        </div>
                      ) : tableData?.type === "text" ? (
                        <p
                          className={`${style.tableDataFontStyle} ${tableData?.onClickFunction && data?.contractType !== "BATCH" && (!tableData?.isRowClickable || tableData.isRowClickable(data, index)) ? style.cursorPointer : ""} ${style.verticalAlignCenter}`}
                          style={!tableData?.onClickFunction ? { cursor: "default", pointerEvents: "none" } : {}}
                          onClick={
                            tableData?.onClickFunction
                              ? () => {
                                console.log("Contract Type1233:", data?.contractType);
                                tableData?.onClickFunction(data, index);
                              }
                              : () => { }
                          }
                        >
                          {tableData?.value?.[index]}
                        </p>
                      ) : tableData?.type === "deleteRecord" ? (
                        <p
                          className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                          onClick={
                            tableData?.onClickFunction
                              ? () => {
                                tableData?.onClickFunction(
                                  data,
                                  index,
                                  "deleteRecord"
                                );
                              }
                              : () => { }
                          }
                        >
                          <Tooltip title={"Delete Role"} placement="top">
                            {tableData?.value?.[index]}
                          </Tooltip>
                        </p>
                      ) : tableData?.type === "editRecord" ? (
                        <p
                          className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                          onClick={
                            tableData?.onClickFunction
                              ? () => {
                                tableData?.onClickFunction(
                                  data,
                                  index,
                                  "editRecord"
                                );
                              }
                              : () => { }
                          }
                        >
                          <Tooltip title={"Edit Role"} placement="top">
                            {tableData?.value?.[index]}
                          </Tooltip>
                        </p>
                      ) : tableData?.type === "textContractRecord" ? (
                        <p
                          className={`${style.tableDataFontStyle2} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                          onClick={
                            tableData?.onClickFunction
                              ? () => {
                                tableData?.onClickFunction(data, index);
                              }
                              : () => { }
                          }
                        >
                          {tableData?.value?.[index]}
                        </p>
                      ) : tableData?.type === "numbers" ? (
                        <p
                          className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.alignCenter}`}
                          onClick={
                            tableData?.onClickFunction
                              ? () => {
                                tableData?.onClickFunction(data, index);
                              }
                              : () => { }
                          }
                        >
                          {tableData?.value?.[index]}
                        </p>
                      ) : tableData?.type === "eCatsPopup" ? (
                        <p
                          style={{
                            marginLeft:
                              selectedContract === "recordsreviewrequire"
                                ? "24%"
                                : "0",
                          }}
                          className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenterEcats}`}
                          onClick={
                            tableData?.onClickFunction
                              ? () => {
                                tableData?.onClickFunction(
                                  data,
                                  index,
                                  "eCatsPopup"
                                );
                              }
                              : () => { }
                          }
                        >
                          {tableData?.value?.[index]}
                        </p>
                      ) : tableData?.type === "bluebox" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              display: "flex",
                              color: "rgb(113, 101, 227)",
                              borderRadius: "15px",
                              height: "28px",
                              background: "#C4C8D066",
                              fontWeight: "700",
                              justifyContent: "center",
                              marginTop: "12px",
                              fontSize: "11px",
                              alignItems: "center",
                              width: "auto",
                              padding: "9px",
                            }}
                            className={`${style.cursorPointer}`}
                            onClick={
                              tableData?.onClickFunction
                                ? () => {
                                  tableData?.onClickFunction(data, index);
                                }
                                : () => { }
                            }
                          >
                            {tableData?.value?.[index]}
                          </p>
                        </div>
                      ) : tableData?.type === "textWithWarning" ? (
                        <div
                          className={`${style.displayInRow} ${style.verticalAlignCenter}`}
                        >
                          <div
                            style={{
                              width: "24px",
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            {tableData?.value?.[index]?.hasWarning && (
                              <img
                                src={Alert}
                                alt="Warning"
                                className={style.warningIcon}
                                style={{ width: "16px", height: "16px" }}
                              />
                            )}
                          </div>
                          <p
                            className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                            onClick={
                              tableData?.onClickFunction
                                ? () => {
                                  tableData?.onClickFunction(data, index);
                                }
                                : () => { }
                            }
                          >
                            {tableData?.value?.[index]?.text ||
                              tableData?.value?.[index]}
                          </p>
                        </div>
                      ) : tableData?.type === "textWithHover" ? (
                        <div>
                          <p
                            className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                            onMouseEnter={(e) =>
                              handleClickTextWithHover(e, index, tableDataIndex)
                            }
                            onMouseLeave={() => handleCloseTextWithHover()}
                            aria-owns={
                              openTextWithHover
                                ? "mouse-over-popover"
                                : undefined
                            }
                            aria-haspopup="true"
                          >
                            {tableData?.value?.[index]}
                          </p>
                          {index === selectedMenuIndex &&
                            tableDataIndex === selectedMenuColIndex &&
                            tableData?.value?.[index] !== "-" && (
                              <Popover
                                id={"mouse-over-popover"}
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={openTextWithHover}
                                anchorEl={anchorElTextWithHover}
                                onClose={handleCloseTextWithHover}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                                disableRestoreFocus
                              >
                                {tableData?.hoverText?.[index]?.map(
                                  (data, innerIndex) => (
                                    <div className={style.multipleOptionsCard}>
                                      <div
                                        className={`${style.specificActionCard} ${style.cursorPointer}`}
                                      >
                                        {data}
                                      </div>
                                    </div>
                                  )
                                )}
                              </Popover>
                            )}
                        </div>
                      ) : tableData?.type === "countWithHover" ? (
                        <div>
                          <p
                            className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                            onMouseEnter={(e) =>
                              handleClickCountWithHover(
                                e,
                                index,
                                tableDataIndex
                              )
                            }
                            onMouseLeave={() => handleCloseCountWithHover()}
                            aria-owns={
                              openCountWithHover
                                ? "mouse-over-popover"
                                : undefined
                            }
                            aria-haspopup="true"
                          >
                            {tableData?.value?.[index]}
                          </p>
                          <div className={style.popoverStyle}>
                            <Popover
                              id={"mouse-over-popover"}
                              sx={{
                                pointerEvents: "none",
                              }}
                              open={openCountWithHover}
                              anchorEl={anchorElCountWithHover}
                              onClose={handleCloseCountWithHover}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              disableRestoreFocus
                            >
                              <div
                                className={style.actionsCard}
                                ref={countHoverRef}
                              >
                                <div
                                  className={`${style.specificActionCard} ${style.cursorPointer}`}
                                >
                                  {" "}
                                  Name
                                </div>
                              </div>
                            </Popover>
                          </div>
                        </div>
                      ) : tableData?.type === "iconWithCount" ? (
                        <div
                          onMouseEnter={(e) =>
                            handleClickIconWithCount(e, index, tableDataIndex)
                          }
                          onMouseLeave={() => handleCloseIconWithCount()}
                          aria-owns={
                            openIconWithCount ? "mouse-over-popover" : undefined
                          }
                          aria-haspopup="true"
                        >
                          <Typography
                            className={`${style.displayInRow} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                          >
                            {tableData?.icon?.[index]}
                            <p
                              className={`${style.tableDataFontStyle} ${style.marginTop10} ${style.marginLeft5}`}
                            >
                              {tableData?.value?.[index]}
                            </p>
                            {tableData?.isShowHoverText &&
                              index === selectedMenuIndex &&
                              tableDataIndex === selectedMenuColIndex &&
                              tableData?.value?.[index] !== "-" && (
                                <Popover
                                  id={"mouse-over-popover"}
                                  sx={{
                                    pointerEvents: "none",
                                  }}
                                  open={openIconWithCount}
                                  anchorEl={anchorElIconWithCount}
                                  onClose={handleCloseIconWithCount}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  disableRestoreFocus
                                >
                                  {tableData?.hoverText?.[index]?.map(
                                    (data, innerIndex) => (
                                      <div
                                        className={style.multipleOptionsCard}
                                      >
                                        <div
                                          className={`${style.specificActionCard} ${style.cursorPointer}`}
                                        >
                                          {" "}
                                          {data}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </Popover>
                              )}
                          </Typography>
                        </div>
                      ) : tableData?.type === "icon" ? (
                        <div
                          onMouseEnter={(e) =>
                            handleClickIcon(e, index, tableDataIndex)
                          }
                          onMouseLeave={() => handleCloseIcon()}
                          aria-owns={
                            openIcon ? "mouse-over-popover" : undefined
                          }
                          aria-haspopup="true"
                        >
                          <Typography
                            className={`${style.cursorPointer} ${style.verticalAlignCenter}`}
                          >
                            {tableData?.icon?.[index]}
                            {tableData?.isShowHoverText &&
                              index === selectedMenuIndex &&
                              tableDataIndex === selectedMenuColIndex && (
                                <Popover
                                  id={"mouse-over-popover"}
                                  sx={{
                                    pointerEvents: "none",
                                  }}
                                  open={openIcon}
                                  anchorEl={anchorElIcon}
                                  onClose={handleCloseIcon}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  disableRestoreFocus
                                >
                                  <div className={style.actionsCard}>
                                    <div
                                      className={`${style.specificActionCard} ${style.cursorPointer}`}
                                    >
                                      {" "}
                                      {tableData?.hoverText?.[index]}
                                    </div>
                                  </div>
                                </Popover>
                              )}
                          </Typography>
                        </div>
                      ) : tableData?.type === "blueicon" ? (
                        <div
                          style={{
                            display: "flex",
                            // color: "rgb(113, 101, 227)",
                            borderRadius: "15px",
                            fontWeight: "700",
                            justifyContent: "center",
                            fontSize: "11px",
                            alignItems: "center",
                          }}
                          onMouseEnter={(e) =>
                            handleClickIcon(e, index, tableDataIndex)
                          }
                          onMouseLeave={() => handleCloseIcon()}
                          aria-owns={
                            openIcon ? "mouse-over-popover" : undefined
                          }
                          aria-haspopup="true"
                        >
                          <Tooltip
                            title={tableData?.icon?.[index]?.props?.alt || ""}
                            arrow
                          >
                            <Typography
                              className={`${style.cursorPointer} ${style.verticalAlignCenter}`}
                            >
                              {tableData?.icon?.[index]}
                              {tableData?.isShowHoverText &&
                                index === selectedMenuIndex &&
                                tableDataIndex === selectedMenuColIndex && (
                                  <Popover
                                    style={{ height: "23px" }}
                                    id={"mouse-over-popover"}
                                    sx={{
                                      pointerEvents: "none",
                                    }}
                                    open={openIcon}
                                    anchorEl={anchorElIcon}
                                    onClose={handleCloseIcon}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}
                                    disableRestoreFocus
                                  >
                                    <div className={style.actionsCard}>
                                      <div
                                        className={`${style.specificActionCard} ${style.cursorPointer}`}
                                      >
                                        {" "}
                                        {tableData?.hoverText?.[index]}
                                      </div>
                                    </div>
                                  </Popover>
                                )}
                            </Typography>
                          </Tooltip>
                        </div>
                      ) : tableData?.type === "site" ? (
                        tableData?.value?.[index]?.length !== 0 ? (
                          <div
                            className={`${style.displayInRow} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                            onMouseEnter={(e) =>
                              handleClickSite(e, index, tableDataIndex)
                            }
                            onMouseLeave={() => handleCloseSite()}
                            aria-owns={
                              openSite ? "mouse-over-popover" : undefined
                            }
                            aria-haspopup="true"
                          >
                            <Typography
                              className={`${style.displayInRow} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                            >
                              <p
                                className={`${style.tableDataFontStyle} ${style.marginTop10} ${style.marginLeft5}`}
                              >
                                {tableData?.value?.[index]?.length}
                              </p>
                              {index === selectedMenuIndex &&
                                tableDataIndex === selectedMenuColIndex &&
                                tableData?.value?.[index] !== "-" && (
                                  <Popover
                                    id={"mouse-over-popover"}
                                    sx={{
                                      pointerEvents: "none",
                                    }}
                                    open={openSite}
                                    anchorEl={anchorElSite}
                                    onClose={handleCloseSite}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}
                                    disableRestoreFocus
                                  >
                                    <div className={style.actionsCard}>
                                      {tableData?.value?.[index]?.map(
                                        (siteData, siteIndex) => (
                                          <div
                                            className={`${style.siteCard} ${style.cursorPointer}`}
                                            key={siteIndex}
                                          >
                                            {siteData?.siteName?.siteName}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </Popover>
                                )}
                            </Typography>
                          </div>
                        ) : (
                          <div
                            className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                          >
                            -
                          </div>
                        )
                      ) : tableData?.type === "department" ? (
                        tableData?.value?.[index]?.length !== 0 ? (
                          <div
                            className={`${style.displayInRow} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                            onMouseEnter={(e) =>
                              handleClickDept(e, index, tableDataIndex)
                            }
                            onMouseLeave={() => handleCloseDept()}
                            aria-owns={
                              openDept ? "mouse-over-popover" : undefined
                            }
                            aria-haspopup="true"
                          >
                            <p
                              className={`${style.tableDataFontStyle} ${style.marginTop10} ${style.marginLeft5}`}
                            >
                              {tableData?.count?.[index]}
                              {index === selectedMenuIndex &&
                                tableDataIndex === selectedMenuColIndex && (
                                  <Popover
                                    id={"mouse-over-popover"}
                                    sx={{
                                      pointerEvents: "none",
                                    }}
                                    open={openDept}
                                    anchorEl={anchorElDept}
                                    onClose={handleCloseDept}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}
                                    disableRestoreFocus
                                  >
                                    <div className={style.actionsCard}>
                                      {tableData?.value?.[index]?.map(
                                        (siteData, siteIndex) => (
                                          <>
                                            <div
                                              className={`${style.siteCard} ${style.cursorPointer}`}
                                              key={siteIndex}
                                            >
                                              {siteData?.siteName?.siteName}
                                            </div>
                                            {siteData?.departmentList?.departments?.map(
                                              (deptData, deptIndex) => (
                                                <div
                                                  className={`${style.deptCard} ${style.cursorPointer}`}
                                                  key={deptIndex}
                                                >
                                                  {
                                                    deptData?.departmentName
                                                      ?.name
                                                  }
                                                </div>
                                              )
                                            )}
                                          </>
                                        )
                                      )}
                                    </div>
                                  </Popover>
                                )}
                            </p>
                          </div>
                        ) : (
                          <div
                            className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.verticalAlignCenter}`}
                          >
                            -
                          </div>
                        )
                      ) : tableData?.type === "action" ? (
                        (() => {
                          // Row-level hide: if predicate says hide, render nothing here
                          if (
                            typeof shouldHideActionMenuForRow === "function" &&
                            shouldHideActionMenuForRow(data)
                          ) {
                            return <div />; // keep grid structure; no "..." icon
                          }

                          // Determine if the action menu should be shown for this row
                          let showMenu = true;
                          if (
                            hideActionMenuIfNoActions &&
                            actions &&
                            Array.isArray(actions)
                          ) {
                            showMenu = actions.some((action) => {
                              if (typeof action.conditionToShow === "string") {
                                try {
                                  // 'data' is the current row's data object
                                  // eslint-disable-next-line no-eval
                                  return eval(action.conditionToShow);
                                } catch {
                                  return false;
                                }
                              }
                              return true;
                            });
                          }
                          if (!showMenu) return null;
                          return (
                            <div
                              className={`${style.tableDataFontStyle} ${style.cursorPointer} ${style.alignCenter}`}
                              onClick={
                                actions?.[0]?.conditionToShow !== undefined &&
                                  actions?.length === 1
                                  ? eval(actions?.[0]?.conditionToShow)
                                    ? () => {
                                      setShowOptions(true);
                                      setSelectedMenuIndex(index);
                                    }
                                    : () => { }
                                  : () => {
                                    setShowOptions(true);
                                    setSelectedMenuIndex(index);
                                  }
                              }
                            >
                              {actions?.[0]?.conditionToShow !== undefined &&
                                actions?.length === 1 ? (
                                eval(actions?.[0]?.conditionToShow) && (
                                  <MoreHorizIcon
                                    className={style.cursorPointer}
                                    onClick={(e) => handleClick(e)}
                                    aria-describedby={id}
                                  />
                                )
                              ) : (
                                <MoreHorizIcon
                                  className={style.cursorPointer}
                                  onClick={(e) => handleClick(e)}
                                  aria-describedby={id}
                                />
                              )}
                              {showOptions && index === selectedMenuIndex && (
                                <Popover
                                  id={id}
                                  open={open}
                                  anchorEl={anchorEl}
                                  onClose={handleClose}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                >
                                  <div
                                    className={style.actionsCard}
                                    ref={menuRef}
                                  >
                                    {actions?.map((actionsData, actionsIndex) =>
                                      actionsData?.conditionToShow !==
                                        undefined ? (
                                        eval(actionsData?.conditionToShow) && (
                                          <div
                                            className={`${style.specificActionCard} ${style.cursorPointer}`}
                                            onClick={() => {
                                              actionsData?.onClick(data);
                                              handleClose();
                                            }}
                                            key={actionsIndex}
                                          >
                                            {actionsData?.data}
                                          </div>
                                        )
                                      ) : (
                                        <div
                                          className={`${style.specificActionCard} ${style.cursorPointer}`}
                                          onClick={() => {
                                            actionsData?.onClick(data, index);
                                            handleClose();
                                          }}
                                          key={actionsIndex}
                                        >
                                          {actionsData?.data}
                                        </div>
                                      )
                                    )}
                                  </div>
                                </Popover>
                              )}
                            </div>
                          );
                        })()
                      ) : tableData?.type === "actionactivitylog" ? (
                        <div
                          className={`${style.tableDataFontStyle2} ${style.cursorPointer} ${style.alignCenter}`}
                          onClick={() => handleHistory(data)}
                        >
                          {/* {console.log(data, "ojufhgvjmnkjn",tableData?.recordUniqueId)} */}
                          <div
                            style={{
                              color: "#7165E3",
                              border: "1px solid #7165E3",
                              borderRadius: "20px",
                              padding: "3px 6px",
                              fontSize: "smaller",
                              fontWeight: "600",
                            }}
                          >
                            History
                          </div>
                        </div>
                      ) : tableData?.type === "contractType" ? (
                        <div
                          className={`${style.tableDataFontStyle2} ${style.cursorPointer}`}
                        >
                          {(() => {
                            // Use custom renderer if provided
                            if (customCellRenderers?.contractType) {
                              return customCellRenderers.contractType(
                                tableData?.value?.[index],
                                tableData?.[index]
                              );
                            }

                            // Default contract type rendering
                            const value = tableData?.value?.[index];
                            if (!value) return <span>-</span>;

                            const contractType = value?.toLowerCase() || "";
                            let icon = null;
                            let tooltip = "";

                            // Contract type icon mapping
                            const iconMap =
                              contractConfig?.contractTypeIcons || {};
                            if (
                              contractType.includes("multiple") ||
                              contractType.includes("multi")
                            ) {
                              icon =
                                iconMap["MULTIPLE"] ||
                                iconMap["MULTI_PROVIDER"];
                              tooltip = "Multiple Provider Contract";
                            } else if (contractType.includes("solo")) {
                              icon =
                                iconMap["SOLO"] || iconMap["SOLO_PROVIDER"];
                              tooltip = "Solo Provider Contract";
                            } else if (contractType.includes("batch_parent")) {
                              icon = iconMap["BATCH_PARENT_PROVIDER"];
                              tooltip = "Batch Parent Provider Contract";
                            } else if (contractType.includes("batch_child")) {
                              icon = iconMap["BATCH_CHILD_PROVIDER"];
                              tooltip = "Batch Child Provider Contract";
                            }

                            return icon ? (
                              <Tooltip title={tooltip} arrow>
                                <img
                                  src={icon}
                                  alt={tooltip}
                                  style={{ height: 20 }}
                                />
                              </Tooltip>
                            ) : (
                              <span>{value}</span>
                            );
                          })()}
                        </div>
                      ) : tableData?.type === "contractorBadge" ? (
                        <div className={`${style.tableDataFontStyle2}`}>
                          {(() => {
                            // Use custom renderer if provided
                            if (customCellRenderers?.contractorBadge) {
                              return customCellRenderers.contractorBadge(
                                tableData?.value?.[index],
                                tableData?.[index]
                              );
                            }

                            // Default contractor badge rendering
                            const value = tableData?.value?.[index];
                            if (typeof value === "object" && value !== null) {
                              const { display, onClick, isClickable } = value;
                              const badgeStyle = {
                                backgroundColor: isClickable
                                  ? "#857AEF"
                                  : "#ccc",
                                color: "white",
                                borderRadius: "12px",
                                padding: "4px 8px",
                                fontSize: "12px",
                                cursor: isClickable ? "pointer" : "default",
                                display: "inline-block",
                                minWidth: "20px",
                                textAlign: "center",
                              };

                              return (
                                <span
                                  style={badgeStyle}
                                  onClick={isClickable ? onClick : undefined}
                                >
                                  {display}
                                </span>
                              );
                            }
                            return <span>{value}</span>;
                          })()}
                        </div>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                </>
              ))
            ) : (
              // <div>
              //     <div className={style.noDataTextStyle}>Bad news!</div>
              //     <p className={style.noDataTextStyle}>no records found so far...</p>
              // </div>
              <NoDataBox
                heading={heading}
                subHeading={subHeading}
                onClickText={onClickText}
                buttonComponent={buttonComponent}
                onClickFunction={onClickFunction}
              />
            )}
          </div>

          {!hidePagination && (totalCount || tableData?.length) > 1 && (
            <Pagination
              selectPage={getSelectedPage}
              totalCount={totalCount}
              selectedPage={page || 1}
            />
          )}

          {historyPop && (
            <HistoryPopup
              historyData={historyData}
              historyHearderData={historyHearderData}
              setHistoryPop={setHistoryPop}
            />
          )}
        </div>
      </div>
    )
  );
};

export default Table;
